/**
 * @file Object search reducer.
 */

import { UPDATE_ALBUM_FOLDER_OBJECT_SEARCH } from '../actions/album-folder-object-search';

export const initialState = {
  searchQuery: '',
  entityId: null,
};

const albumFolderObjectSearchReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case UPDATE_ALBUM_FOLDER_OBJECT_SEARCH:
      return {
        ...state,
        searchQuery: action.searchQuery,
        entityId: action.entityId,
      };
    default:
      return state;
  }
};

export default albumFolderObjectSearchReducer;
